import ArticleInfo from '@/components/BlogComponents/shared/ArticleInfo/ArticleInfo';
import Link from '@/components/Link/Link';
import type { BlogPageType } from '@/contentful/api/types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BlogCuratedArticleList.style';

export default function BlogCuratedArticleList({
  heading,
  articles,
}: {
  heading?: string;
  articles: BlogPageType[];
}): React.JSX.Element {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div className={classes.wrapper}>
      {heading && (
        <h3 className={cx(globalClasses.h3, classes.listHeading)}>{heading}</h3>
      )}
      <div>
        {articles.map((article: BlogPageType, idx: number) => {
          const { blogTitle, publicationDate, readTimeMinutes, path } = article;
          return (
            <div
              key={`${blogTitle}-${
                // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
                idx
              }`}
              className={classes.articleCard}
              data-testid={`article-item-${idx + 1}`}
            >
              <h4 className={cx(globalClasses.h4, classes.articleHeading)}>
                <Link href={path} title={blogTitle}>
                  {blogTitle}
                </Link>
              </h4>
              <ArticleInfo
                publicationDate={publicationDate}
                readingTime={readTimeMinutes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
